import React from 'react';
import PropTypes from 'prop-types';

import Image from 'components/Image';

export default function Advert({ image, url }) {
  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      <Image icon={image} type="ad" />
    </a>
  );
}

Advert.propTypes = {
  image: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};